import { createContext, useContext } from "react";
import type { FileLinkTarget } from "./fileLinks";

/** Opens a file an agent linked to in a workspace document tab, scrolled to the
 * cited lines. Only a workspace page has tabs to open into, so outside one this
 * is null and such links stay inert. */
export const FileOpenerContext = createContext<((target: FileLinkTarget, inNewTab: boolean) => void) | null>(null);

export function useFileOpener() {
  return useContext(FileOpenerContext);
}
